import { render, staticRenderFns } from "./tel-phone-row.vue?vue&type=template&id=07619dce"
import script from "./tel-phone-row.vue?vue&type=script&lang=js"
export * from "./tel-phone-row.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports